module.exports = "/_next/static/images/8a10f5cc159efa540965d0d23125c1f6-payed.png";